import React from "react";
import { downArrow } from "../assets/down-arrow";
import { motion } from "framer-motion";

function Header({ div }) {
  return (
    <div className="h-[100vm] lg:h-fit lg:min-h-[calc(100vh-80px)] bg-blend-overlay bg-black/10 bg-top bg-cover bg-header-background bg-no-repeat bg-fixed text-white flex justify-center items-center">
      <motion.div
        className="text-center w-[90%] py-10 lg:w-[60%]"
        animate={{ y: 0, opacity: 1, transition: { duration: 0.8 } }}
        initial={{ y: 75, opacity: 0 }}
      >
        <motion.h1
          animate={{ y: 0, opacity: 1, transition: { duration: 0.8 } }}
          initial={{ y: -100, opacity: 0 }}
          className="font-bold text-4xl lg:text-8xl"
        >
          مرحباً بكم في تيراب محصول
        </motion.h1>
        <p className="[text-shadow:_0_4px_8px_rgb(0_0_0_/_40%)] font-medium text-md lg:font-medium lg:text-2xl py-9 lg:py-10 leading-6">
          مرحبًا بك في موقعنا الإلكتروني المتخصص في عالم الزراعة والمحاصيل. نحن
          هنا لنقدم لك تجربة شاملة ومتكاملة للحصول على المعلومات والخدمات التي
          تحتاجها لنجاح نشاطك الزراعي. سواء كنت مزارعًا , تاجرا ام مقدم للخدمات
          الزراعية المختلفة ، فإننا نقدم لك مجموعة من الخدمات والميزات
        </p>
        <button
          onClick={() =>
            div.current.scrollIntoView({
              behavior: "smooth",
              block: "end",
            })
          }
          className="text-center"
        >
          {downArrow}
        </button>
      </motion.div>
    </div>
  );
}

export default Header;
